import styled, {css} from 'styled-components';
import {getColorFromTheme} from '@ui/ui-utils';

export const NotificationPage = styled.div`
  width: 100%;
  max-width: 100%;
`;

export const PageIntro = styled.div`
  margin-bottom: 24px;

  h3 {
    margin-bottom: 8px;
  }
`;

export const ChannelCard = styled.section`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  background: ${getColorFromTheme('white')};
  overflow: hidden;

  & + & {
    margin-top: 16px;
  }
`;

export const ChannelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding: 24px;

  @media (max-width: 600px) {
    padding: 20px 16px;
    gap: 16px;
  }
`;

export const ChannelHeading = styled.div`
  min-width: 0;

  h4 {
    margin-bottom: 4px;
  }
`;

export const PreferenceGroups = styled.div`
  border-top: 1px solid ${getColorFromTheme('borderLight')};
`;

export const PreferenceGroup = styled.section`
  padding: 20px 24px 8px;

  & + & {
    border-top: 1px solid ${getColorFromTheme('borderLight')};
  }

  @media (max-width: 600px) {
    padding: 18px 16px 6px;
  }
`;

export const GroupTitle = styled.div`
  margin-bottom: 8px;

  p:first-child {
    margin-bottom: 2px;
  }
`;

export const PreferenceRow = styled.div<{disabled?: boolean}>`
  min-height: 68px;
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;

  & + & {
    border-top: 1px solid ${getColorFromTheme('borderLight')};
  }

  ${({disabled}) =>
    disabled &&
    css`
      opacity: 0.72;
    `}

  @media (max-width: 600px) {
    gap: 12px;
  }
`;

export const PreferenceCopy = styled.div`
  min-width: 0;
  flex: 1;

  > div {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 2px;
  }
`;

export const PreferenceStatus = styled.div`
  min-height: 20px;
  margin-top: 8px;
`;
